<div class="border-gray-200 relative">
  <table class="bg-gray-100 dark:bg-dark-hover border-collapse table-fixed w-full overflow-hidden rounded-t-md">
    <thead>
    <tr>
      <th class="w-1/4 bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">
        {{  'timeSeries.missing.time' | translate }}
      </th>
      <th class="border-slate-200 dark:border-dark-border border text-sm text-left font-normal text-primary dark:text-dark-text dark:bg-dark-hover px-2 py-1">
        {{ 'timeSeries.missing.consumption' | translate }}
      </th>
      <th class="border-slate-200 dark:border-dark-border border text-sm text-left font-normal text-primary dark:text-dark-text dark:bg-dark-hover px-2 py-1 w-1/6">
        <div class="flex items-center">
          {{ 'timeSeries.missing.measured' | translate }}
          <input
            type="checkbox"
            class="ml-2 h-4 w-4"
            [checked]="areAllMeasured()"
            (change)="toggleAllMeasured($event)"
            [attr.aria-pressed]="areAllMeasured()"
            [title]="areAllMeasured() ? ('timeSeries.missing.unselectAll' | translate) : ('timeSeries.missing.selectAll' | translate)"
          />
        </div>
      </th>
      @if (timeSeriesAverage && timeSeriesAverage.length > 0) {
        <th class="border-slate-200 dark:border-dark-border border text-sm text-left font-normal text-primary dark:text-dark-text dark:bg-dark-hover px-2 py-1">
          {{ 'timeSeries.missing.estimated' | translate }}
        </th>
      }
    </tr>
    </thead>
    <tbody>
      @for (t of timeSeries; track t.readingTs; let index = $index) {
        <tr class="odd:bg-white dark:odd:bg-dark-card even:bg-none">
          <td class="text-primary dark:text-dark-text font-normal text-sm py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
            @if (t.readingTs) {
              {{ getTimeRange(t.readingTs, t.resolution) }}
            }
          </td>
          <td class="text-primary dark:text-dark-text py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
            <input class="!min-w-12" appInputNumber [decimals]="3" [selectOnFocus]="true" [(ngModel)]="t.consumption" />
          </td>
          <td class="text-primary dark:text-dark-text py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
            <input type="checkbox" [ngModel]="t.consumptionType === ReadingType.Ok" (ngModelChange)="$event ? t.consumptionType = ReadingType.Ok : t.consumptionType = undefined" />
          </td>
          @if (timeSeriesAverage) {
            <td class="text-secondary text-sm py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
              {{ timeSeriesAverage[index].consumption ?? '0,000' }}
            </td>
          }
        </tr>
      }
    </tbody>
    <tfoot>
      <tr class="bg-gray-100 dark:bg-dark-hover">
        <td class="text-primary dark:text-dark-text font-medium text-sm py-2.5 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-t-2 border-b">
          {{ 'common.sum' | translate }}
        </td>
        <td class="text-primary dark:text-dark-text font-medium text-sm py-2.5 px-2 border-slate-200 dark:border-dark-border border-r border-t-2 border-b">
          {{ getTotalConsumption() | number:'1.0-3':'da' }}
        </td>
        <td class="border-slate-200 dark:border-dark-border border-r border-t-2 border-b"></td>
        @if (timeSeriesAverage && timeSeriesAverage.length > 0) {
          <td class="text-secondary font-medium text-sm py-2.5 px-2 border-slate-200 dark:border-dark-border border-r border-t-2 border-b">
            {{ getTotalEstimated() | number:'1.0-3':'da' }}
          </td>
        }
      </tr>
    </tfoot>
  </table>
</div>
